import { Button } from "@arcadeai/design-system/components/ui/atoms/button";
import {
  Dialog,
  DialogTrigger,
} from "@arcadeai/design-system/components/ui/atoms/dialog";
import { Plus } from "lucide-react";
import { useMemo, useState } from "react";
import { CanOrg } from "@/app/capabilities/components/can-org";
import { ORG } from "@/app/capabilities/permissions";
import { ListLayout } from "@/components/custom/list-layout/list-layout";
import { useOrgProjectRouteContext } from "@/lib/org-project-context/hooks";
import { useGetProjects } from "./api/hooks";
import { CreateProjectModal } from "./components/create-project-modal";
import { columns } from "./data-table/columns";
import { ProjectsTable } from "./data-table/projects-table";
import { useProjectsViewOptions } from "./hooks/use-projects-view-options";

export const ProjectsList = () => {
  const { organizationId } = useOrgProjectRouteContext();
  const { data: projects } = useGetProjects(organizationId);
  const [isOpen, setIsOpen] = useState(false);
  const COLUMNS = useMemo(() => columns, []);

  const { columnVisibility, setColumnVisibility } = useProjectsViewOptions();

  return (
    <ListLayout
      actions={
        <CanOrg permission={ORG.projects.create}>
          <Dialog onOpenChange={setIsOpen} open={isOpen}>
            <DialogTrigger render={<Button size="sm" />}>
              <Plus className="mr-0 size-4 sm:mr-2" />
              <span className="hidden sm:block">Add Project</span>
            </DialogTrigger>
            <CreateProjectModal setIsOpen={setIsOpen} />
          </Dialog>
        </CanOrg>
      }
      description="Organize resources, manage team access, and separate environments for your workflows."
      title="Projects"
    >
      <ProjectsTable
        columns={COLUMNS}
        columnVisibility={columnVisibility}
        data={projects}
        onColumnVisibilityChange={setColumnVisibility}
      />
    </ListLayout>
  );
};
